import { atom } from 'recoil';

export const candidateId = atom({
  key: "candidateId",
  default: null
});

export const currentCandidateData = atom({
    key: "currentCandidateData",
    default: null
  });
